import { render, staticRenderFns } from "./CourseOrders.vue?vue&type=template&id=5fa0f7d8&"
import script from "./CourseOrders.vue?vue&type=script&lang=js&"
export * from "./CourseOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports